import {Component, inject, input} from '@angular/core'
import {DecimalPipe} from '@angular/common'
import {HemnetService} from '../../../services/hemnet.service'

@Component({
  selector: 'spb-item',
  imports: [
    DecimalPipe
  ],
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent {
  public readonly value = input.required<number>()
  public readonly label = input.required<string>()

  public readonly service = inject(HemnetService)
}
